import React from 'react'
import './LoadingSpinner.css'

export type LoadingSpinnerSize = 'xs' | 'sm' | 'md' | 'lg'
export type LoadingSpinnerColor =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'warning'
  | 'error'

export interface LoadingSpinnerProps {
  /** Size of the loading spinner */
  size?: LoadingSpinnerSize
  /** Color variant of the loading spinner */
  color?: LoadingSpinnerColor
  /** Additional CSS classes */
  className?: string
  /** Accessible label for screen readers */
  label?: string
  /** Whether to show the spinner inline with text */
  inline?: boolean
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'xs',
  color,
  className = '',
  label = 'Loading...',
  inline = false,
}) => {
  const colorClass = color ? `loading-${color}` : ''
  const inlineClass = inline ? 'loading-inline' : ''

  return (
    <span
      className={`loading loading-${size} loading-spinner ${colorClass} ${inlineClass} ${className}`.trim()}
      aria-label={label}
      role="status"
      aria-live="polite"
    />
  )
}

export default LoadingSpinner
